export const configQuery = 'settingByDeployedProductId';
export const unitTestNodeInConfig = 'Unittest';

export const translationQuery = 'translationsByLanguageTag';
export const unitTestNodeInTranslation = 'unittest';

export const operationQuery = 'operationSummariesByTimeRange';
export const operationSchema = `
{
  items{
    id
    startTime
    endTime
    acid
    airline
    runwayName
    airportId
    remoteAirportId
    operationType
    aircraftCategory
    time
    points
    {
      lat
      lon
      alt
    }
  }
}
`;

export const infringementRulesQuery = 'infringementRules';
export const infringementRulesSchema = `
  {
    id
    infringementType
    description
    name
    candidateFilter {
      aircraftCategories
      aircraftTypes
      airportRunways {
        airportId
        runwayNames
      }
      daysOfWeek
      endTime
      lowestMaxTakeOffWeight
      lowestMinLandingWeight
      operationTypes
      operatorCategories
      pathName
      queryString
      startTime
    }
    ... on CcoInfringementRule {
      id
      maxAltitudeVariation
      autoInfringementSegmentLength
      ceilingAltitude
      floorAltitude
      maxLevelSegments
      minLevelSegmentLength
    }
    ... on CdoInfringementRule {
      id
      maxAltitudeVariation
      autoInfringementSegmentLength
      ceilingAltitude
      floorAltitude
      maxLevelSegments
      minLevelSegmentLength
    }
    ... on CorridorInfringementRule {
      id
      name
      allowedPassage
      ceilingAltitude
      corridorId
    }
    ... on GateInfringementRule {
      gateCriteria {
        altitudeRange {
          start
          end
        }
        gateDirections
        gateId
        intersectionMode
        speedRange {
          start
          end
        }
      }
    }
    ... on CurfewInfringementRule {
      candidateFilter {
        startTime
        endTime
      }
    }
    ... on ExclusionInfringementRule {
      selectionZoneId
    }
    ... on MinHeightInfringementRule {
      id
      requiredAltitude
      flightDistance
    }
    ... on NoiseInfringementRule {
      metric
      thresholds {
        locationId
        threshold
      }
    }
  }
`;
